import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'deltacapita-toast-alert',
    templateUrl: './toast-alert.component.html',
    styleUrls: ['./toast-alert.component.scss'],
    standalone: false
})

export class ToastAlertComponent implements OnInit {

  @Input() type;
  @Input() bodyText;
  @Input() action;
  @Input() dismissible;

  show = true;

  constructor() { }

  ngOnInit(): void {
  }

  close() {
    this.show = !this.show;
  }

  refresh() {
    window.location.reload();
  }

  getToastClass() {
    return `alert alert-${this.type}`
  }


}
